import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuOrderStatusView } from "src/tenantCustomizations/tenants/mellano/views/luukku/production/MellanoLuukkuOrderStatusView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/orderStatus")({
	staticData: { title: "Tilaustilanne", legacyViewKey: "mellanoLuukkuOrderStatusView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuOrderStatusView />;
}
